import type { GetPreviewUrlKey } from "./types";

// A re-signed asset URL differs only in its signature query params; the
// pathname is the stable identity, so React keys built from it never remount
// a panel just because the signature was refreshed.
export const getPreviewUrlKey: GetPreviewUrlKey = (url) => {
  try {
    return new URL(url).pathname;
  } catch {
    // Empty or relative values (no signed URL yet) are their own identity.
    return url;
  }
};
